<div class="payment-release-container">
    <div class="close-modal" (click)="closeModal()">
        <span>X</span>
    </div>
    <div class="">
        <div class="title pb-2">{{'PAYMENT_RELEASE_TITLE'| translate}}</div>
        <p class="pb-2">{{'PAYMENT_RELEASE_TEXT1' | translate}} <strong>{{'PAYMENT_RELEASE_TEXT2'|translate}}</strong>.</p>
        <div class="elements-container">
            <div class="elements" *ngFor="let contract of contractsReleasePayment">
                <div class="element d-flex align-items-start gap-1 p-1">
                    <div class="checkbox-input"><input type="checkbox" [checked]="contract.active" name="" id="" (change)="addPaymentReleaseContract(contract,$event)" [disabled]="validateContractFacman(contract.contractId)"></div>
                    <div class="list-element">{{'Cuenta'|translate}} <span>{{contract.idReferenceContract}}
                            ({{contract.type}})</span> - {{contract.ownerName}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex align-items-center justify-content-center pt-4">
        <button [disabled]="loadingPaymentsRelease" class="btn btn-primary" (click)="openSystemAuth()">{{'SAVE_CHANGES'|translate}}</button>
    </div>
</div>
